var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoCircleGray400(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.81451 2.81463C4.14087 1.48829 5.97511 0.666748 7.99996 0.666748C10.0248 0.666748 11.8591 1.48829 13.1854 2.81463L12.714 3.28603L13.1854 2.81463C14.5117 4.14099 15.3333 5.97523 15.3333 8.00008C15.3333 10.0249 14.5117 11.8592 13.1854 13.1855C11.8591 14.5119 10.0248 15.3334 7.99996 15.3334C5.97511 15.3334 4.14087 14.5119 2.81451 13.1855L3.28591 12.7141L2.81451 13.1855C1.48817 11.8592 0.666626 10.0249 0.666626 8.00008C0.666626 5.97524 1.48817 4.14099 2.8145 2.81463L2.81451 2.81463ZM7.99996 2.00008C6.34294 2.00008 4.84385 2.67092 3.75731 3.75744C2.67079 4.84398 1.99996 6.34306 1.99996 8.00008C1.99996 9.6571 2.6708 11.1562 3.75732 12.2427C4.84385 13.3292 6.34294 14.0001 7.99996 14.0001C9.65698 14.0001 11.1561 13.3292 12.2426 12.2427C13.3291 11.1562 14 9.6571 14 8.00008C14 6.34306 13.3291 4.84397 12.2426 3.75744C11.1561 2.67092 9.65698 2.00008 7.99996 2.00008Z",
    fill: "#888888"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99996 3.66675C8.46019 3.66675 8.83329 4.03985 8.83329 4.50008C8.83329 4.96031 8.46019 5.33341 7.99996 5.33341C7.53973 5.33341 7.16663 4.96031 7.16663 4.50008C7.16663 4.03985 7.53973 3.66675 7.99996 3.66675Z",
    fill: "#888888"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.83337 6.66667C6.83337 6.29848 7.13185 6 7.50004 6H8.16671C8.5349 6 8.83337 6.29848 8.83337 6.66667V11.3333C8.83337 11.7015 8.5349 12 8.16671 12C7.79852 12 7.50004 11.7015 7.50004 11.3333V7.33333C7.13185 7.33333 6.83337 7.03486 6.83337 6.66667Z",
    fill: "#888888"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.33337 11.3334C6.33337 10.9652 6.63185 10.6667 7.00004 10.6667H9.33337C9.70156 10.6667 10 10.9652 10 11.3334C10 11.7016 9.70156 12.0001 9.33337 12.0001H7.00004C6.63185 12.0001 6.33337 11.7016 6.33337 11.3334Z",
    fill: "#888888"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCircleGray400);
export default __webpack_public_path__ + "static/media/info_circle_gray400.9b1c94420c8e62a860d7489e82ae2f29.svg";
export { ForwardRef as ReactComponent };